import React, {ReactNode} from "react"
import {Link} from "@tanstack/react-router"

type SiteLogoProps = {
    linkToHome?: boolean
}

export default function SiteLogo({linkToHome = true}: SiteLogoProps) {
    const wrapInLink = (image: ReactNode) => linkToHome
        ? <Link to="/" params="" search="">{image}</Link>
        : image

    return <div className="logo">
        {wrapInLink(<img src="/pck.svg" alt="PCK AS logo bilde"/>)}
    </div>
}
